import React, { useEffect } from 'react';
import mqttClient from 'hooks/MqttClient';
import { useDispatch } from 'react-redux';
import { addMessage , setClient } from 'actions/mqtt';

function MqttConnection() {
  const client = mqttClient();
  const dispatch = useDispatch();

  useEffect(() => {
    if (client) {

      dispatch(setClient(client));
      client.on('connect', () => {
        console.info('connect', 3242)
      });
      client.on('error', (err) => {
        console.error('Connection error: ', err);
        client.end();
      });
      client.on('reconnect', () => {
        console.info('Reconnecting')
      });
      client.on('message', (topic, message) => {
        const payload = { topic, message: message.toString() };
        const newData = JSON.parse(`${payload.message}`);
        dispatch(addMessage({
          ...newData ,
          topic : payload.topic
        }));
      })

      mqttSub({
        topic: `#`, qos: 2
      })

    }
    return () => {
      mqttUnSub({
        topic: `#`
      })
    }
  }, [client])

  const mqttUnSub = (subscription) => {
    if (client) {
      const { topic } = subscription;
      client.unsubscribe(topic, error => {
        if (error) {
          console.error('Unsubscribe error', error)
          return
        }

      });
    }
  };

  const mqttSub = (subscription) => {
    if (client) {
      const { topic, qos } = subscription;

      client.subscribe(topic, { qos }, (error) => {
        if (error) {
          console.error('Subscribe to topics error', error)
          return
        }
      });
    }
  };

  return (
    <div>
    </div>
  );
}

export default MqttConnection;